import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row Types (SQLite shapes — booleans are 0/1) ───

export interface FrontDeskSettingsRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  enabled: number | null; // 0/1
  default_appointment_status_id: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface FrontDeskProviderSettingRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  provider_id: string | null;
  enabled: number | null; // 0/1
  created_at: string | null;
  updated_at: string | null;
}

export interface FrontDeskServiceSettingRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  service_id: string | null;
  enabled: number | null; // 0/1
  duration_override_mins: number | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface FrontDeskFieldSettingRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  field_key: string | null;
  enabled: number | null; // 0/1
  required: number | null; // 0/1
  locked: number | null; // 0/1
  section: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

export function qFrontDeskSettings(): QuerySpec<[]> {
  return {
    key: ['frontdesk-settings'] as const,
    sql: `SELECT * FROM booking_frontdesk_settings LIMIT 1`,
    params: [],
    watch: ['booking_frontdesk_settings'],
  };
}

export function qFrontDeskProviderSettings(): QuerySpec<[]> {
  return {
    key: ['frontdesk-provider-settings'] as const,
    sql: `SELECT * FROM booking_frontdesk_provider_settings ORDER BY provider_id ASC`,
    params: [],
    watch: ['booking_frontdesk_provider_settings'],
  };
}

export function qFrontDeskServiceSettings(): QuerySpec<[]> {
  return {
    key: ['frontdesk-service-settings'] as const,
    sql: `SELECT * FROM booking_frontdesk_service_settings ORDER BY service_id ASC`,
    params: [],
    watch: ['booking_frontdesk_service_settings'],
  };
}

export function qFrontDeskFieldSettings(): QuerySpec<[]> {
  return {
    key: ['frontdesk-field-settings'] as const,
    sql: `SELECT * FROM booking_frontdesk_patient_field_settings ORDER BY field_key ASC`,
    params: [],
    watch: ['booking_frontdesk_patient_field_settings'],
  };
}

// ─── Mappers ───

export function mapFrontDeskSettingsToUI(row: FrontDeskSettingsRow) {
  return {
    id: row.id,
    enabled: row.enabled == 1,
    defaultAppointmentStatusId: row.default_appointment_status_id ?? null,
  };
}

export function mapFrontDeskFieldToUI(row: FrontDeskFieldSettingRow) {
  return {
    id: row.id,
    fieldKey: row.field_key ?? '',
    enabled: row.enabled == 1,
    required: row.required == 1,
    locked: row.locked == 1,
    section: row.section ?? '',
  };
}
